'use client';

import type { EndpointReturnDto } from '@terra/shared-contracts-endpoints';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Badge } from '../../';
import { SectionTitle } from './SectionTitle';
import { MarkdownSection } from './MarkdownSection';
import { formatEndpointBodySchema } from './formatEndpointBodySchema';

type WebSocketSchemaSectionProps = {
  data: EndpointReturnDto;
};

export function WebSocketSchemaSection({ data }: WebSocketSchemaSectionProps) {
  const t = useTranslations('designSystem.applicationAssets.sections');
  const websocket = data.websocket;
  const outbound = formatEndpointBodySchema(websocket?.outboundMessageSchema);
  const inbound = formatEndpointBodySchema(websocket?.inboundMessageSchema);

  if (!outbound.content && !inbound.content && !websocket?.subprotocol) {
    return null;
  }

  return (
    <Box flexShrink={0}>
      <VStack gap={4} alignItems="stretch">
        {websocket?.subprotocol ? (
          <HStack gap={2} alignItems="center">
            <SectionTitle>{t('websocketSubprotocol')}</SectionTitle>
            <Badge size="sm" variant="emphasis">
              {websocket.subprotocol}
            </Badge>
          </HStack>
        ) : null}

        {outbound.content ? (
          <MarkdownSection
            title={t('websocketOutboundSchema')}
            source={outbound.content}
            language={outbound.language}
          />
        ) : null}

        {inbound.content ? (
          <MarkdownSection
            title={t('websocketInboundSchema')}
            source={inbound.content}
            language={inbound.language}
          />
        ) : null}
      </VStack>
    </Box>
  );
}
